import { render, staticRenderFns } from "./showOrder.vue?vue&type=template&id=d95aabb0"
import script from "./showOrder.vue?vue&type=script&lang=js"
export * from "./showOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports